import { useEffect } from "react";
import LogRocket from "logrocket";
import * as Sentry from "@sentry/react";

import { setLogRocketSessionUrl } from "@/utils/logrocketSession";

const LogRocketComponent = () => {
  useEffect(() => {
    LogRocket.init(process.env.LOGROCKET_APP_ID);
    // Once the replay URL resolves, (1) stash it so API requests can correlate
    // backend logs with this session, and (2) tag Sentry events with it so a
    // Sentry error can deep-link to its session replay. The ops dashboard reads
    // this "logrocket" tag off the latest event to render the replay link.
    // Errors before the URL resolves just won't carry the tag.
    LogRocket.getSessionURL((url) => {
      setLogRocketSessionUrl(url);
      Sentry.setTag("logrocket", url);
    });
  }, []);
  return null;
};

export default LogRocketComponent;
